import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import type {
  ConductorCreativeUnpricedBrandInlineFields,
  CreativeFlightsUnpricedBrandInline,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getFlightsUnpricedBrandInlineCreative = (
  fields: ConductorCreativeUnpricedBrandInlineFields,
): CreativeFlightsUnpricedBrandInline => {
  const {
    appIndex,
    callToActionText = null,
    carriersCriteria,
    ctaButtonTitleEnabled,
    excludedCarriers,
    includedCarriers,
    message,
    partner,
    partnerDesktopLogo,
    partnerLogo,
    pioAgencyName,
    pioPartnerName,
    redirectUrl,
    splitTestId,
    title,
  } = fields;

  return {
    appIndex,
    callToActionText,
    ctaButtonTitleEnabled: ctaButtonTitleEnabled === 'true',
    format: ADVERT_FORMAT_TYPES.UNPRICED_BRAND_INLINE,
    message,
    partnerDesktopLogo,
    partnerLogo,
    partner: partner || null,
    redirectUrl,
    title,
    carriersCriteria: carriersCriteria || 'all',
    includedCarriers: includedCarriers ? includedCarriers.split(',').map(Number) : [],
    excludedCarriers: excludedCarriers ? excludedCarriers.split(',').map(Number) : [],
    splitTestId,
    pioPartnerName,
    pioAgencyName,
  };
};
